import { ApiResponse } from "shared/Types/responseTypes"
import { post } from "shared/Helpers/http"
import { TransactionResponse } from "shared/Modules/Transaction/transactionTypes"
import { RefillOrderRequest } from "./InitializeRefill"
import { CurrentEnvironment } from "shared/Modules/Environment/envTypes"

export default function createWalletsRefill(
    request: { order: RefillOrderRequest },
    walletId: number,
    acquirerSetupId: number,
    token: string,
    environment: CurrentEnvironment,
    userId?: number
): Promise<ApiResponse<TransactionResponse>> {
    return post(`/users/${userId}/acquirerSetups/${acquirerSetupId}/wallets/${walletId}/orders`, {
        body: request,
        token,
        environment,
    })
}
